<template lang="pug">
.dawn-tab-nav-wrapper(:class='{ "wide": wide }')
  .dawn-tab-content(v-if='bottomTabs')
    slot
  .dawn-tab-nav(:class='{ "wide": wide, "tabs": options }')
    div(:class='{ "container-fluid": wide || options, "text-center": steps }')
      ul(:class='{ "even-spaced": workflow, "wide container": wide }')
        li(v-for='tab in tabList.length ? tabList : tabs'
          :class='tabClass(tab)'
          @click='options ? "" : selectTab(tab)'
          )
          a(v-if='tab.href' :href='steps ? "javascript:;" : tab.href')
            span.tab-icon-wrapper(v-if='tab.icon')
              i(:class='[{ "complete": tab.isCompleted || steps }, tab.iconClass ]')
            span.tab-title-wrapper {{tab.title}}
          
          a(href='#' @click.prevent='clickTab(tab)' v-if='tab.to')
            span.tab-icon-wrapper(v-if='tab.icon')
              i(:class='[{ "complete": tab.isCompleted || steps }, tab.iconClass ]')
            span.tab-title-wrapper {{tab.title}}
  .dawn-tab-content(v-if='!bottomTabs')
    slot
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */

import EdTab from '@/core/components/edTabNav/edTab.vue'
import Modules from '@/components/_modules'
import { EventBus } from '@/event-bus'

export default {
  name: 'ed-tab-nav',

  components: {
    'ed-tab': EdTab
  },

  props: {
    workflow: { type: Boolean, default: false },
    wide: { type: Boolean, default: false },
    steps: { type: Boolean, default: false },
    options: { type: Array, default: function () { return [] } },
    activeTab: Object,
    callback: Function,
    bottomTabs: Boolean
  },

  data() {
    return {
      tabs: [],
      lastTabIdx: {},
      tabClass(tab) {
        return {
          'is-active text-color line-color': tab.isActive,
          'is-completed text-color line-color': tab.isCompleted || this.steps,
          'optional': tab.optional,
          'valid': tab.valid
        }
      }
    }
  },

  computed: {
    //
    tabList() {
      return this.options || this.tabs
    }
  },

  created() {
    if (!this.options.length) {
      this.tabs = this.$children
    }
    this.legacy = true || Modules[this.$route.params.page] && Modules[this.$route.params.page].notImplemented
  },

  mounted() {
    // go to active tab
    // this.goToTab()
    this.goToActiveTab()
  },

  updated() {
    //
    this.updateLegacyTabs()
  },

  methods: {
    clickTab(tab) {
      if (typeof this.activeTab.isValid === 'boolean') {
        if (this.activeTab.isValid) {
          this.callback(tab, true)
        } else {
          this.lastTabIdx = this.options.indexOf(tab)
          this.callback(tab, true)
        }
      }
      if (typeof this.activeTab.isValid === 'function') {
        if (this.activeTab.isValid()) {
          this.callback(tab, true)
        } else {
          this.lastTabIdx = this.options.indexOf(tab)
        }
      }
      console.log('end')
    },

    goToTab() {
      var tabHash = this.$route.hash
      this.tabs.forEach(tab => tab.section === tabHash && this.selectTab(tab))
    },

    selectTab(activeTab, previous) {
      const vm = this
      let allowRouteChange = false

      // reference to previously selected tab
      const previouslySelectedTab = this.getActiveTab()
      const prev = previous || previouslySelectedTab

      const endpoint = prev &&
                       prev.$el.querySelector('form') &&
                       prev.$el.querySelector('form').getAttribute('no-submit') === null &&
                       prev.$el.querySelector('form').getAttribute('endpoint')

      let tabToActivate = null

      this.tabs.forEach((tab, i) => {
        const prevTab      = i === 0 ? vm.tabs[0] : vm.tabs[i - 1]
        const prevTabValid = i === 0 ||
                             prevTab.$el.querySelector('form') &&
                             prevTab.$el.querySelector('form').checkValidity() ||
                             prevTab.optional && !prevTab.$attrs.errors
        const tabValid     = prev &&
                             prev.$el.querySelector('form') &&
                             prev.$el.querySelector('form').checkValidity()
        const noErrors     = activeTab.optional && !activeTab.$attrs.errors

        const check        = this.$attrs.check

        if ((!this.$attrs.steps || check) && activeTab && activeTab.href === tab.href) {
          //
          // select tab
          // if previous tab is valid
          if (prevTabValid && !noErrors) {
            tabToActivate = tab
            allowRouteChange = true
          }

          // skip tab
          // if tab is optional and has no errors
          if (noErrors && tabValid) {
            const nextTab = vm.tabs[i + 1]

            nextTab.valid = true
            vm.selectTab(nextTab, previouslySelectedTab)
            return
          }
        } else {
          tab.isActive = false
        }
      })

      if (tabToActivate && vm.findPrevTab()) {
        if (tabToActivate.section === vm.findPrevTab().section) {
          vm.findPrevTab().valid && activateTab()
        }
        // return
      }

      if (endpoint &&
          (!previouslySelectedTab || previouslySelectedTab.section !== activeTab.section) &&
          ((previouslySelectedTab && activeTab.optional) || !activeTab.optional)
      ) {
        // let requestPayload = previouslySelectedTab && previouslySelectedTab.$attrs.payload
        let requestPayload = prev.$attrs.payload
        let requestPayloadType = prev.$attrs.payloadType

        if (requestPayload) {
          requestPayload = {
            map: requestPayloadType === 'json' ? requestPayload : JSON.stringify(requestPayload),
            filePath: vm.$el.getAttribute('file-id'),
            userId: vm.$user.$.user.UserID,
            vendorId: vm.$user.$.data.VendorID,
            vci: vm.$user.$.user.VCI
          }
        }

        // !previouslySelectedTab && vm.api.post(endpoint, requestPayload)
        (tabToActivate && tabToActivate.optional ||
        vm.findPrevTab(tabToActivate) &&
        vm.findPrevTab(tabToActivate).optional ||
        vm.findPrevTab(tabToActivate) &&
        typeof vm.findPrevTab(tabToActivate).$attrs.additional !== 'undefined'
        ) &&
        vm.api.post(endpoint, requestPayload)
          .then(activateTab)
          .catch(e => console.warn(e, 'Server error'))
      } else {
        activateTab()
      }

      function activateTab(response) {
        if (activeTab && allowRouteChange) {
          const errorsTab = vm.findPrevTab(tabToActivate)

          // inject feedback response
          vm.$emit('tabSelected', {
            response,
            from : prev
          })

          vm.$nextTick(() => {
            const errors = errorsTab && errorsTab.optional && errorsTab.$attrs.errors

            let _tabToActivate = /* response && !response.data ? vm.findNextTab(tabToActivate) : */tabToActivate
            let _activeTab = /* response && !response.data ? vm.findNextTab(activeTab) : */activeTab

            if (errors) {
              _tabToActivate = errorsTab
              _activeTab = errorsTab
              tabToActivate.valid = false
            }

            // activate tab
            _tabToActivate.isActive = true
            // _tabToActivate.valid = true

            // change route
            vm.$router.push({ hash: _activeTab.section })

            // emit event
            vm.$emit('tabSelected', {
              from : prev,
              to   : _activeTab
            })
          })
        }
      }
    },

    goToNextTab() {
      const vm = this
      let nextTabIndex = null

      this.tabs.forEach((tab, i) => {
        if (tab.isActive && i < vm.tabs.length - 1) {
          // tab.isActive = false
          nextTabIndex = i + 1
          return false
        }
      })

      nextTabIndex && vm.selectTab(vm.tabs[nextTabIndex])
    },

    findNextTab(ofTab) {
      const vm = this
      let nextTabIndex = null

      this.tabs.forEach((tab, i) => {
        if (ofTab && ofTab.section === tab.section && i > 0) {
          nextTabIndex = i + 1
          return false
        } else if (tab.isActive) {
          nextTabIndex = i + 1
        }
      })

      return nextTabIndex && vm.tabs[nextTabIndex]
    },

    findPrevTab(ofTab) {
      const vm = this
      let prevTabIndex = null

      this.tabs.forEach((tab, i) => {
        if (ofTab && ofTab.section === tab.section && i > 0) {
          prevTabIndex = i - 1
          return false
        } else if (tab.href === '#' + this.$route.fullPath) {
          prevTabIndex = i - 1
        }
      })

      return (prevTabIndex !== null) && vm.tabs[prevTabIndex]
    },

    reset() {
      this.tabs.forEach(tab => (tab.isActive = false))
      this.selectTab(this.tabs[0])
      this.$emit('tabSelected')
    },

    goToActiveTab() {
      if (!this.legacy || !this.$attrs.steps) {
        this.tabs.forEach(tab => {
          if (tab.isActive) {
            this.$router.replace(tab.section)
            return
          }
        })
      }
    },

    getActiveTab() {
      let activeTab = null

      if (this.legacy) {
        this.tabs.forEach(tab => {
          if (tab.isActive) {
            activeTab = tab
          }
        })
      }

      return activeTab
    },

    updateLegacyTabs() {
      const vm = this

      if (this.legacy) {
        this.tabs.forEach((tab, i) => {
          const prevTab      = i === 0 ? vm.tabs[0] : vm.tabs[i - 1]
          const prevTabValid = i === 0 ||
                               prevTab.$el.querySelector('form') &&
                               prevTab.$el.querySelector('form').checkValidity()
          const tabValid     = i === 0 ||
                               tab.$el.querySelector('form') &&
                               tab.$el.querySelector('form').checkValidity()

          if (prevTabValid) prevTab.valid = true

          tab.isActive = tab.href === '#' + this.$route.fullPath &&
                         ((!this.$attrs.steps || (prevTabValid || prevTab.optional && !prevTab.$attrs.errors)))
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-tab-nav-wrapper {
  margin-left: -15px;
  margin-right: -15px;

  &.wide {
    margin: 0;
  }

  &.steps {
    ul {
      counter-reset: LIST-ITEMS;

      li.valid + li,
      li.valid + li:hover,
      li.valid + li:before,
      li.valid + li a {
        cursor: pointer;
      }
    }
    ul > li {
      height: 5.5em;

      &, &:hover, &:before, a {
        cursor: not-allowed;
      }
      &.is-active,
      &.valid,
      &.is-active:hover,
      &.valid:hover,
      &.is-active:before,
      &.valid:before,
      &.is-active a,
      &.valid a {
        cursor: pointer;
      }

      &:before {
        font-size: $font-size-large;
        display: inline-block;
        content: counter(LIST-ITEMS);
        counter-increment: LIST-ITEMS;
        width: 40px;
        height: 40px;
        line-height: 38px;
        padding-left: 1px;
        text-align: center;
        border-radius: 20px;
        @include theme {
        background: v(background);
        box-shadow: inset 0 0 5px v(border);
        }
      }

      &.is-active {
        &:before {
          @include theme {
          background: v(attention-01);
          }
        }

        &.optional:before {
          @include theme {
          background: v(urgent-01);
          }
        }
      }
      &.valid:before {
        @include theme {
        background: v(tertiary-01);
        }
      }
    }
  }
}

.uniform {
  li {
    width: 6rem;
    text-align: center;
    height: 7rem;
    vertical-align: top;

    .tab-title-wrapper {
      display: block;
      position: absolute;
      bottom: .5rem;
      left: 0;
      right: 0;
      line-height: 1.1;
    }
  }

  &.steps.steps li {
    border-bottom: 0;
  }
}

.dawn-tab-nav {
  border-bottom: $border;
  @include theme {
  border-color: v(background);
  }

  &.wide {
    @include theme {
    border-bottom: $border-width-default solid $background-light;
    }
  }

  &.tabs {
    @include theme {
    border-bottom: $border-width-default solid $background-light;
    }

    ul {
      padding: 0;
      margin-bottom: 0;
      
      @include theme {
      border-bottom: none;
      }
      
      li {
        &:hover, &.is-active {
          margin-top: 8px;
        }
      }
    }
  }

  ul {
    display: inline-block;
    list-style: none;
    padding-left: .75rem;
    padding-right: .75rem;
    margin-bottom: 1rem;
    width: 100%;
    padding-bottom: .15rem;
    @include theme {
    border-bottom: $border-width-default solid $background-light;
    }

    &.wide {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;

      li {
        border-bottom: .1rem solid;
        vertical-align: bottom;
      }
      li, li a {
        font-size: $font-size-base;
        line-height: 1.8em;
        text-transform: none;
      }
    }

    &.even-spaced {
      display: table;

      li {
        display: table-cell;
        .uniform & .tab-title-wrapper {
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
    }

    li {
      position: relative;
      display: inline-block;
      margin: .5rem 2.5rem 0rem 0rem;
      padding-bottom: .3em;
      font-weight: $font-weight-bold;
      border-bottom: .2rem solid;
      @include theme {
      border-color: v(background-light);
      }
      //transition: all .2s ease-in-out;
      vertical-align: bottom;

      &:hover, &.is-active {
        margin-top: -.1rem;
        cursor: pointer;
        a {
          margin-top: -.1rem;
        }
      }

      .tab-icon-wrapper {
        display: block;
        font-size: 2.75rem;
        text-align: center;
        @include theme {
        color: v(background-light);
        }
        transition: all .2s ease-in-out;
      }

      a {
        @include theme {
        color: v(background-light);
        }
        text-decoration: none;
        transition: all .2s ease-in-out;
      }

      &.is-completed {
        @include theme {
        border-color: v(border);
        }

        .tab-icon-wrapper {
          @include theme {
          color: v(border);
          }
        }

        a {
          @include theme {
          color: v(border);
          }
        }
      }

      &.is-active, &:hover {
        border-bottom: .2rem solid;
        @include theme {
        border-color: v(tertiary-01);
        }

        .tab-icon-wrapper {
          @include theme {
          color: v(ink);
          }
        }

        a {
          @include theme {
          color: v(primary-04);
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edTabNav/index.vue